import { apiDelete, apiGet, apiPost, apiPut } from '../utils/apiClient';

const jsonUtf8Headers = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json; charset=utf-8',
};

export default class CampaignMessagesIntegrations {
    listMessages(botApiUrl, authToken) {
        return apiGet(`${botApiUrl}/campaign/message`, { authToken });
    }

    listMessagesFalse(botApiUrl, authToken) {
        return apiGet(`${botApiUrl}/campaign/message/approved/false`, { authToken });
    }

    listMessagesTrue(botApiUrl, authToken) {
        return apiGet(`${botApiUrl}/campaign/message/approved/true`, { authToken });
    }

    saveCampaignMessage(botApiUrl, templateMessage, botId, authToken) {
        return apiPost(
            `${botApiUrl}/campaign/message/${botId}`,
            templateMessage,
            { authToken, headers: jsonUtf8Headers }
        );
    }

    updateCampaignMessage(botApiUrl, templateMessage, botId, authToken) {
        return apiPut(
            `${botApiUrl}/campaign/message/admin/${botId}`,
            templateMessage,
            { authToken, headers: jsonUtf8Headers }
        );
    }

    deleteMessage(botApiUrl, message, botId, authToken) {
        return apiDelete(`${botApiUrl}/campaign/message/${botId}`, {
            authToken,
            json: true,
            body: message,
            headers: jsonUtf8Headers,
        });
    }
}
